import { render, staticRenderFns } from "./Radiobox.vue?vue&type=template&id=03dff9fa&scoped=true&lang=pug&"
import script from "./Radiobox.vue?vue&type=script&lang=js&"
export * from "./Radiobox.vue?vue&type=script&lang=js&"
import style0 from "./Radiobox.vue?vue&type=style&index=0&id=03dff9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dff9fa",
  null
  
)

export default component.exports